import React from 'react';
import { FormattedMessage } from 'react-intl';
import { App } from '@gin-betting/core';
import cn from 'classnames';

import { Icon } from 'components';
import messages from 'messages';
import { Action, Category, Label } from 'services/analytics';
import FeaturedTournamentsRow from './FeaturedTournamentsRow';
import useFeaturedTournaments from './useFeaturedTournaments';

import arrow from 'assets/svg/top-tournaments-arrow.svg';
import './featuredTournaments.scss';

const { LOADED, LOADING, INITIAL, FAILED } = App.FetchStatus;

const FeaturedTournaments: React.FC = () => {
    const {
        featuredConfigs,
        toggleExpand,
        isExpanded,
        isShowExpandButton,
        fetchStatus,
    } = useFeaturedTournaments();

    if ([LOADED, FAILED].includes(fetchStatus) && featuredConfigs.size === 0) {
        return null;
    }

    return (
        <div styleName="container">
            <div styleName="header">
                <span styleName="title ">
                    <FormattedMessage {...messages.featured} />
                </span>
            </div>

            {[INITIAL, LOADING].includes(fetchStatus) ? (
                <div styleName="load" />
            ) : (
                <React.Fragment>
                    <div styleName="body">
                        {featuredConfigs.map(config => (
                            <FeaturedTournamentsRow
                                key={config.slug}
                                config={config}
                            />
                        ))}
                    </div>

                    {isShowExpandButton && (
                        <div
                            styleName={cn('icon-container', {
                                'is-rotated': isExpanded,
                            })}
                            data-category={Category.FiltersFeatured}
                            data-action={Action.ToggleMore}
                            data-label={isExpanded ? Label.Close : Label.Open}
                            onClick={toggleExpand}
                        >
                            <Icon glyph={arrow} styleName="icon" />
                        </div>
                    )}
                </React.Fragment>
            )}
        </div>
    );
};

export default React.memo(FeaturedTournaments);
